import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    p: "p",
    strong: "strong",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "A New Date, Same High-Speed Drama"
      })
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "The Saudi Arabian Grand Prix returns April 18-20, 2025, later in the season for the first time. Expect nicer weather, stunning coastal sunsets, and even faster night racing under the floodlights."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "Since its debut in 2021, Jeddah’s race has quickly become a fan-favorite — famous for its blistering speed, its dramatic battles, and its stunning track that hugs the Red Sea."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "🔥 Fastest Street Circuit in F1 (Average speeds over 250 km/h)\n🏆 Where Legends Clash, Remember Verstappen vs Hamilton 2021?\n🌊 27 Corners (Most in F1), Iconic Night Racing, and Coastal Views"
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "The Global Championship Returns in 2025"
      })
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.p, {
      children: "Formula 1 is the pinnacle of motorsport, where the fastest drivers on earth battle across 24 rounds in iconic locations — from the streets of Monaco to the deserts of Saudi Arabia to the neon lights of Las Vegas. In 2025, the story gets even bigger, with:"
    }), "\n", _jsx("br", {}), "\n", _jsxs(_components.p, {
      children: ["✅ New driver line-ups  ", _jsx("br", {}), "\n✅ Technical updates to the cars  ", _jsx("br", {}), "\n✅ Rivalries heating up  ", _jsx("br", {}), "\n✅ One of the longest calendars ever  ", _jsx("br", {})]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
